import React, { useContext, useState } from 'react';
import Balneario from './components/balneario/balneario';
import Lista from './components/lista/lista';
import { DiefCfemContext } from '../../../../../../../contexts/DiefCfemContext';
import { useQuery } from '@tanstack/react-query';
import { IDadosOutrosRegimes, PaginasOutrosRegimes } from '../../../../../../../interfaces/IDadosOutrosRegimes';
import { useBackEndRequests } from '../../../../../lib/backEndRequests';
import { BrDivider, BrLoading, Col, Row } from '@govbr-ds/react-components';
import styles from './componentesBaseCalculo.module.scss';
import { formatarNrProcesso } from '../../../../../../../utils/formatNrProcesso';
import ReceitaBruta from './components/receitaBruta/receitaBruta';
import VendaNacional from './components/vendaNacional/vendaNacional';
import ReceitaExportacoes from './components/receitaExportacoes/receitaExportacoes';
import ReceitaBrutaCalculada from './components/receitaBrutaCalculada/receitaBrutaCalculada';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

interface IComponentesBaseCalculoOutrosRegimesProps {
  setStepFormulario: React.Dispatch<React.SetStateAction<number>>;
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  baseDeCalculo: PaginasOutrosRegimes;
}

const ComponentesBaseCalculoOutrosRegimes = ({
  setStepFormulario,
  baseDeCalculo,
  setBaseDeCalculo,
}: Readonly<IComponentesBaseCalculoOutrosRegimesProps>) => {
  const [isEdicao, setIsEdicao] = useState(false);

  const context = useContext(DiefCfemContext);
  const idOperacao = context?.idOperacaoEditar || '';

  const { getDadosOperacaoOutrosRegimesById } = useBackEndRequests();

  const {
    data: dadoOperacao,
    isLoading,
    refetch: refetchDados,
    isRefetching,
  } = useQuery<IDadosOutrosRegimes, IErrorWithSentryId>({
    queryKey: ['dadosOutrosRegimes', idOperacao],
    queryFn: () => getDadosOperacaoOutrosRegimesById(idOperacao),
    refetchOnWindowFocus: false,
    enabled: idOperacao !== '',
    staleTime: 0,
    refetchOnMount: true,
  });

  const baseDeCalculoComponent = () => {
    if (isLoading) {
      return <BrLoading large />;
    }

    if (dadoOperacao) {
      context?.setNrProcessoMinerarioEmPreenchimento(dadoOperacao.numeroProcessoMinerario);
    }

    if (baseDeCalculo === 'lista') {
      return (
        <Lista
          setStepFormulario={setStepFormulario}
          setBaseDeCalculo={setBaseDeCalculo}
          setIsEdicao={setIsEdicao}
          dadoOperacao={dadoOperacao}
          refetchDados={refetchDados}
          isRefetching={isRefetching}
          isLoadingDadosOperacao={isLoading}
        />
      );
    } else if (baseDeCalculo === 'balnearioComBanho') {
      return (
        <Balneario
          isEdicao={isEdicao}
          setIsEdicao={setIsEdicao}
          comBanho={true}
          setStepFormulario={setStepFormulario}
          setBaseDeCalculo={setBaseDeCalculo}
        />
      );
    } else if (baseDeCalculo === 'balnearioSemBanho') {
      return (
        <Balneario
          isEdicao={isEdicao}
          setIsEdicao={setIsEdicao}
          setStepFormulario={setStepFormulario}
          setBaseDeCalculo={setBaseDeCalculo}
          comBanho={false}
        />
      );
    } else if (baseDeCalculo === 'receitaBruta') {
      return <ReceitaBruta isEdicao={isEdicao} setIsEdicao={setIsEdicao} setBaseDeCalculo={setBaseDeCalculo} />;
    } else if (baseDeCalculo === 'vendaNacional') {
      return <VendaNacional isEdicao={isEdicao} setIsEdicao={setIsEdicao} setBaseDeCalculo={setBaseDeCalculo} />;
    } else if (baseDeCalculo === 'receitaExportacoes') {
      return <ReceitaExportacoes isEdicao={isEdicao} setIsEdicao={setIsEdicao} setBaseDeCalculo={setBaseDeCalculo} />;
    } else if (baseDeCalculo === 'receitaBrutaCalculada') {
      return (
        <ReceitaBrutaCalculada isEdicao={isEdicao} setIsEdicao={setIsEdicao} setBaseDeCalculo={setBaseDeCalculo} />
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      {baseDeCalculo !== 'lista' && (
        <>
          <div className={styles.dadosContainer}>
            <Row>
              <Col>
                <span className={styles.label}>Processo Minerário</span>
                <p className={styles.text}>{formatarNrProcesso(dadoOperacao?.numeroProcessoMinerario ?? '')}</p>
              </Col>
              <Col>
                <span className={styles.label}>Substância</span>
                <p className={styles.text}>{dadoOperacao?.substancia}</p>
              </Col>
              <Col>
                <span className={styles.label}>Município/UF</span>
                <p className={styles.text}>
                  {dadoOperacao?.municipio}/{dadoOperacao?.uf}
                </p>
              </Col>
            </Row>
          </div>
          <div className={styles.divider} id='lista-ncm-adicionado'>
            <BrDivider />
          </div>
        </>
      )}
      {baseDeCalculoComponent()}
    </>
  );
};

export default ComponentesBaseCalculoOutrosRegimes;
